import type { Lang } from '@platform/core/types';

const LOCALES: Record<Lang, string> = { uk: 'uk-UA', en: 'en-GB' };

/** Дата: рік приховується, якщо поточний (правило прототипу). */
export function formatDate(iso: string | null | undefined, lang: Lang, withYear = false): string {
  if (!iso) return '';
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return iso;
  const sameYear = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleDateString(LOCALES[lang], { day: 'numeric', month: 'short', ...(withYear || !sameYear ? { year: 'numeric' } : {}) });
}

export function formatDateTime(iso: string, lang: Lang): string {
  const d = new Date(iso);
  return d.toLocaleString(LOCALES[lang], { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}

export function relativeTime(iso: string, lang: Lang): string {
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  const rtf = new Intl.RelativeTimeFormat(LOCALES[lang], { numeric: 'auto' });
  if (minutes < 60) return rtf.format(-minutes, 'minute');
  if (minutes < 1440) return rtf.format(-Math.round(minutes / 60), 'hour');
  return rtf.format(-Math.round(minutes / 1440), 'day');
}

export function isOverdue(due: string | null | undefined, closed: boolean): boolean {
  if (!due || closed) return false;
  return due.slice(0, 10) < new Date().toISOString().slice(0, 10);
}

export function formatNumber(value: number | string | null | undefined, lang: Lang): string {
  if (value === null || value === undefined || value === '') return '';
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isNaN(n) ? String(value) : n.toLocaleString(LOCALES[lang], { maximumFractionDigits: 2 });
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}
